import React, { Component } from 'react';
import { Spin, Col, Button, Icon, Modal, Form, Row, Select, InputNumber, Tooltip } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import moment from 'moment'
import 'moment/locale/es';
import ArticulosPTRequest from '../../services/ArticulosPT';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import { roles } from '../../util/Roles';
import { Diario, Semanal, TotalCiclicos } from '../../constants';
import ArticulosCiclicos from './ArticulosCiclicos';
import ArticulosCiclicosRequest from '../../services/ArticulosCiclicos';
moment.locale('es')
const { Option } = Select;
const { confirm } = Modal;
const exceptThisSymbols = ["e", "E", "+", "-"];

/**
 * Clase para ver el proceso de mostrar form de productos
 */
class FormArticulosCiclicos extends Component {
    state = {
        cargando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        externo: this.props.externo,
        idFrecuencia: this.props.producto_selected.idFrecuencia
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */

    componentDidUpdate(prevProps) {
        if (prevProps.producto_selected.idFrecuencia !== this.props.producto_selected.idFrecuencia) {
            this.setState({ idFrecuencia: this.props.producto_selected.idFrecuencia });
        }
    }


    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.props.form.resetFields();
        this.setState({
            cargando: false
        })
    }

    /**
     * Función que se manda a llamar cuando cambia la variación
     */
    handleChangeVariacion = (ev) => {
        // ev.preventDefault();
    }

    /**
     * Función que se ejecuta cuando se confirma edición de estatus
     * @param: e. valor para prevent
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: this.props.arrArticulos?.length === 1 ? <div><b>¿Está seguro de editar el artículo?</b> Se cambiará la información del artículo seleccionado.</div> : <div><b>¿Está seguro de editar el artículo?</b> Se cambiará la información de los artículos seleccionados.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-estatus-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-estatus-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarProductos)
                    },
                });
            }
        });
    }

    /**
     * Función que se cambia el estatus de los productos
     * @param: nada.
     * @return: nada.
     */
    editarProductos = () => {
        let state = { ...this.state }
        state.bloquearBotones = true;
        state.cargando = true;

        let objEnviar = {};
        objEnviar.id = this.props.producto_selected.id
        objEnviar.frecuencia = this.state.idFrecuencia;

        this.setState(state, () => {
            ArticulosCiclicosRequest.actualizarFrecuenciaArticulo([objEnviar])
                .then(response => {
                    state.cargando = false;
                    state.bloquearBotones = false

                    this.setState(state, this.props.esconderModal(true, response.data))
                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo,
                    )
                })
                .catch(err => {
                    this.setState({ bloquearBotones: false, cargando: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        "Error",
                    )
                })
        })

    }

    visibleVariacion = (value) => {
        if (value) {
            return "block"
        }
        return "none"
    }

    handleChanceFrecuencia = (value) => {
        this.setState({ idFrecuencia: value })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let titulo = "Editar frecuencia " + (this.props.modo === 'uno' ? "del artículo" : "de los artículos");
        return (
            <div>
                <Modal
                    title={titulo}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    // width={"30%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-estatus-productos"
                                className="btnCancelar"
                                key="back"
                                disabled={this.state.bloquearBotones}
                                onClick={this.handleCancel}> Regresar
                            </Button>,
                            <Button
                                id="boton-guardar-form-estatus-productos"
                                className={'btnVerCrearGuardar'}
                                key="submit"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                                type="primary"> Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={24}>
                                    <Select
                                        id="select-estatus-form-productos"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        value={this.state.idFrecuencia}
                                        onChange={this.handleChanceFrecuencia}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        <Option
                                            value={1}
                                            key={1}
                                            disabled={
                                                this.props.producto_selected.idFrecuencia === Semanal
                                                && this.props.diarios === TotalCiclicos
                                            }>Diario
                                        </Option>
                                        <Option
                                            value={2}
                                            key={2}
                                            disabled={
                                                this.props.producto_selected.idFrecuencia === Diario
                                                && this.props.semanales === TotalCiclicos}>Semanal
                                        </Option>
                                    </Select>
                                </Col>
                                <Col span={24}>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormArticulosCiclicos);